const reviews = [
    {
        name: 'John Doe',
        content: 'This event booking service is fantastic! Easy to use and very efficient.',
        rating: 5,
    },
    {
        name: 'Jane Smith',
        content: 'I love the variety of events offered. The booking process was seamless.',
        rating: 4,
    },
    {
        name: 'Sam Wilson',
        content: 'Great customer service and user-friendly website. Highly recommend!',
        rating: 5,
    },
];

export default reviews;